"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Auth;

var _ActionTypes = require("FileManagerCore/actions/ActionTypes");

function Auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      auth = action.auth;

  switch (type) {
    case _ActionTypes.SET_AUTH:
      return auth;

    default:
      return state;
  }
}

module.exports = exports.default;